import React, { useEffect } from 'react'
  import { useID } from "./IdContext";
import { useParams } from 'react-router-dom';

export default function HeadOrderDetails() {

const { id } = useParams();


  return (
    <>
      <div className="order-details d-flex justify-content-between align-items-center my-2 mx-4 ">
        <div className="order-number">
          <p className=" fs-4 text-muted mt-2">
            Order <span className=" fw-bolder text-black">#{id}</span>
          </p>
        </div>
        <div>
          <button className="btn border border-1 p-2 mx-3 text-muted">
            <i className="fa-solid fa-truck "></i> Assign To van
          </button>
          <button className="btn border border-1 p-2 text-muted">
            <i className="fa-solid fa-location-dot me-1"></i>
            Location on map
          </button>
        </div>
      </div>
    </>
  );
}
